const configuredBaseUrl = import.meta.env.VITE_FONT_CATALOG_BASE_URL || 'https://font-flow.pages.dev/'

/**
 * External font catalog root. Self-hosted builds can replace it with
 * VITE_FONT_CATALOG_BASE_URL without touching application code.
 */
export const FONT_CATALOG_BASE_URL = configuredBaseUrl.replace(/\/+$/, '')
export const FONT_CATALOG_MANIFEST_URL = `${FONT_CATALOG_BASE_URL}/manifest.json`

export function getFontCatalogFileUrl(path: string): string {
  return new URL(path, `${FONT_CATALOG_BASE_URL}/`).toString()
}
